import request from '@/utils/request'
let baseURL = '/mall-logistics';

// 查用户下地址list
export function addressList(data) {
  return request({
    url: '/user/address/v1/list',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
openid (string, optional): 用户openid
}
*/

// 区域三级联动
export function areaList(data) {
  return request({
    url: '/user/address/v1/listChoice',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
areaId (integer, optional): 区域行政ID ,
mapType (string, optional): 第三方 映射 目前只有 JD
}
*/

// 创建地址
export function addressAdd(data) {
  return request({
    url: '/user/address/v1/add',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
addresseeName (string, optional): 收件人姓名 ,
addresseeTel (string, optional): 收件人电话 ,

countryAreaId (integer, optional): 国家级平台行政区划ID ,
provinceAreaId (integer, optional): 省级平台行政区划ID ,
cityAreaId (integer, optional): 市级平台行政区划ID ,
countyAreaId (integer, optional): 区/县级平台行政区划ID ,
townAreaId (integer, optional): 街道/镇级平台行政区划ID ,

detailAddress (string, optional): 详细地址（不含国家、省、市、县、街道） ,
isDefault (boolean, optional): 是否默认地址（保证同一用户有且只有一个默认地址） ,
}
*/

// 创建地址
export function addressEdit(data) {
  return request({
    url: '/user/address/v1/update',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
addresseeName (string, optional): 收件人姓名 ,
addresseeTel (string, optional): 收件人电话 ,

countryAreaId (integer, optional): 国家级平台行政区划ID ,
provinceAreaId (integer, optional): 省级平台行政区划ID ,
cityAreaId (integer, optional): 市级平台行政区划ID ,
countyAreaId (integer, optional): 区/县级平台行政区划ID ,
townAreaId (integer, optional): 街道/镇级平台行政区划ID ,

detailAddress (string, optional): 详细地址（不含国家、省、市、县、街道） ,
isDefault (boolean, optional): 是否默认地址（保证同一用户有且只有一个默认地址） ,

userAddressId (integer, optional): 用户地址ID,编辑必传
}
*/

// 查某个地址详情
export function addressDetail(data) {
  return request({
    url: '/user/address/v1/this',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
userAddressId (integer, optional): 用户地址ID
}
*/

// 删除地址
export function deleteAddress(data) {
  return request({
    url: '/user/address/v1/delete',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
userAddressId (integer, optional): 用户地址ID
}
*/


// 查用户最后使用的行政区域
export function latestAddress(data) {
  return request({
    url: '/user/address/v1/latest',
    method: 'post',
    baseURL,
    data
  })
}
/*
{}
*/

// 修改用户最近使用区域
export function updateLatestAddress(data) {
  return request({
    url: '/user/address/v1/latest/update',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
userOpenId (string, optional): 用户OPEN_ID
areaType (string, optional): 'SYS','JD','TAOBAO','PDD',默认SYS ,

provinceAreaId (integer, optional): 省级平台行政区划ID ,
cityAreaId (integer, optional): 市级平台行政区划ID，没有就不传 ,
countyAreaId (integer, optional): 区/县级平台行政区划ID，没有就不传 ,
townAreaId (integer, optional): 街道/镇级平台行政区划ID，没有就不传 ,
}
*/


